import { FC, Fragment } from "react";
import HighlightText from "../HighlightText/index";

interface MultiLineTextProps {
  lines: (string | undefined | null)[];
  as?: "p" | "div" | "span";
  highlight?: string;
}

const MultiLineText: FC<MultiLineTextProps> = ({ lines, as = "p", highlight = "" }) => {
  const validLines = lines.filter(Boolean) as string[];
  const Wrapper = as;

  return (
    <Wrapper>
      {validLines.map((line, index) => (
        <Fragment key={index}>
          <HighlightText text={line} highlight={highlight} />
          {index < validLines.length - 1 && <br />}
        </Fragment>
      ))}
    </Wrapper>
  );
};

export default MultiLineText;
